module.exports = __webpack_public_path__ + "static/media/OH4@2x.79f3898e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OH/OH4@2x.png
// module id = 707
// module chunks = 0